import {AppDto} from 'types/Dto';

import CreateAppProvider from './CreateAppProvider';
import NameField from './NameField';
import SubmitField from './SubmitField';
import TypeField from './TypeField';

const CreateAppForm = ({onCreate}: {onCreate?: (app: AppDto) => any}) => {
  return (
    <CreateAppProvider>
      <CreateAppFormRender onCreate={onCreate} />
    </CreateAppProvider>
  );
};

const CreateAppFormRender = ({onCreate}: {onCreate?: (app: AppDto) => any}) => {
  // const {view} = useCreateApp();
  // const isExpanded = view !== 'confirm';

  return (
    <div className="flex flex-col max-w-3xl mx-auto">
      <div className=" sm:mx-20">
        <span className="py-2 text-[#878787] font-bold text-xs">App Name</span>

        <NameField />
      </div>

      <div className="flex items-center w-full justify-center py-4">
        <div className="flex border-[0.5px] w-full border-gray-300" />

        <div className="mx-6 text-xs text-[#878787] font-bold whitespace-nowrap">
          App Type
        </div>

        <div className="flex  border-[0.5px] w-full border-gray-300" />
      </div>

      <TypeField />

      <SubmitField onCreate={onCreate} />
    </div>
  );
};

export default CreateAppForm;
